import { fetchPayload } from '../../../utils/reducerOperations';
import {
    LOGOUT_START,
    LOGOUT_SUCCESS,
    LOGOUT_FAIL,


} from '../../constants';
import { logOutFailed, logOutStarted, logOutSuccess } from './helper';
import { Default } from './InitialState';


const LogOutReducer = (state = Default(), action) => {
    let payload = fetchPayload(action);
    switch (action.type) {
        case LOGOUT_START:
            return logOutStarted(state, payload);
        case LOGOUT_SUCCESS:
            return logOutSuccess(state, payload);
        case LOGOUT_FAIL:
            return logOutFailed(state, payload);
        default:
            return { ...state };
    }}

export default LogOutReducer;